import { render, staticRenderFns } from "./LanguageTranslationEditPopup.vue?vue&type=template&id=2faf7f6a&"
import script from "./LanguageTranslationEditPopup.vue?vue&type=script&lang=js&"
export * from "./LanguageTranslationEditPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports